// extracted by mini-css-extract-plugin
module.exports = {"rules":"styles_rules__8WZiO"};